export default [
  {
    path: '/admin/roles',
    name: 'admin-roles',
    component: () => import('@/views/roles/Roles.vue'),
    meta: {
      resource: 'roles.view',
      action: 'read',
      pageTitle: 'Roles y Permisos',
      breadcrumb: [
        {
          text: 'Roles y Permisos',
          active: true,
        },
      ],
    },
  },
]
